const Init = () => {


    if( document.getElementById('business') != null ){

      const localNavi = [].slice.call( document.querySelectorAll('.o-localnavi'), 0 );

      if ( localNavi.length > 0 ) {

        const path = location.pathname;
        localNavi.forEach( (v) => {

          const links = [].slice.call( v.querySelectorAll('ul li a'), 0 );
          links.forEach( (v) => {

            const href = v.getAttribute('href');
            if ( href === path) {
              v.classList.add('current');
            };

          });

        });

      };

    };

};

export default Init;
